import PropTypes from 'prop-types';
import React from 'react';
import {Col, Row} from 'react-bootstrap';
import {PageLayout} from '../../../common/look';

const Screen = ({children, header, leftTitle, rightTitle}) => {
  return (
    <PageLayout>
      {header}
      <div className="general-container">
        <div className="section-title">
          <Row>
            <Col xs={6} className="table-name">
              {leftTitle}
            </Col>
            <Col xs={{span: 4, offset: 2}} className="add-brand-btn">
              {rightTitle}
            </Col>
          </Row>
        </div>
        <Row>
          <Col xs={12}>
            {children}
          </Col>
        </Row>
      </div>
    </PageLayout>
  );
};

Screen.propTypes = {
  children: PropTypes.any,
  header: PropTypes.any,
  leftTitle: PropTypes.any,
  rightTitle: PropTypes.any,
};

export default Screen;
